"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformResponseToAggregationInfo = exports.transformPlaidItemActivityToRequestData = exports.transformAccountsToDiscoverAccount = exports.transformResponseToAccountDiscoveryStatus = exports.transformResponseToPartnerAuthUris = exports.transformResponseToAccountDiscoveryData = exports.mergeDiscoveryAggregatorsWithInstitutionLogin = exports.transformInstitutionLoginToRequestData = void 0;
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const types_1 = require("data/institutionLogins/types");
const utils_1 = require("utils/utils");
const types_2 = require("./types");
const log = (0, core_1.getLogger)('data/AccountDiscovery/transformers.ts');
const transformAccountsToRequestData = (accounts) => accounts.reduce((list, account) => {
    list.push(accounts_1.accountsTransformers.transformAccountToRequestData(account));
    return list;
}, []);
const transformInstitutionLoginToRequestData = (institutionLogin, accounts = null) => ({
    cpSetupMode: institutionLogin.cpSetupMode ? institutionLogin.cpSetupMode : 'DISCOVER_ACCOUNTS_ONLY',
    channel: institutionLogin.channel,
    id: institutionLogin.id !== '0' ? institutionLogin.id : null,
    name: institutionLogin.name,
    cpInstitutionId: institutionLogin.cpInstitutionId,
    institutionId: institutionLogin.institutionId,
    credentials: !institutionLogin.credentials ? null : institutionLogin.credentials.map((credential) => ({
        key: credential.key,
        value: credential.value,
    })),
    aggregators: !institutionLogin.aggregators || institutionLogin.aggregators.size === 0 ? null :
        [{
                cpChannel: institutionLogin.aggregators.get(0).channel,
                cpId: institutionLogin.aggregators.get(0).cpId,
            }],
    accounts: accounts != null ? transformAccountsToRequestData(accounts) : null,
});
exports.transformInstitutionLoginToRequestData = transformInstitutionLoginToRequestData;
const mergeDiscoveryAggregatorsWithInstitutionLogin = (discoveryAggregators, institutionLogin) => (institutionLogin.set('aggregators', (0, immutable_1.List)(discoveryAggregators.map((aggregator) => (0, types_1.mkInstitutionLoginAggregator)({
    channel: aggregator.channel,
    cpId: aggregator.cpId,
})))));
exports.mergeDiscoveryAggregatorsWithInstitutionLogin = mergeDiscoveryAggregatorsWithInstitutionLogin;
const transformResponseToAccountDiscoveryData = (data, allAccountsById) => {
    var _a;
    const activeAccounts = [];
    const deadAccounts = [];
    const newAccounts = [];
    const unconnectedAccounts = [];
    (_a = data.accounts) === null || _a === void 0 ? void 0 : _a.forEach((account) => {
        let existingAccount;
        if (account.id) {
            existingAccount = allAccountsById.get(account.id);
            // todo: should we fail if we cannot find existing account
        }
        // todo: need to handle multiple aggregators of different types, for now
        // todo: will will assume just a single aggregator and fix later
        //
        const aggregator = account.aggregators && account.aggregators.length > 0 ? account.aggregators[0] : null;
        log.debug('Account and Aggregator', account, aggregator, aggregator && aggregator.cpDetails);
        // case a: no id - new discovered account (or one QCS does not know about)
        // case b: id but no aggregator - unconnected account
        // case c: id, cpId, cpDetails - active aggregated account
        // case d: id, cpId, but no cpDetails - dead aggregated account
        let discoveredAccount;
        if (aggregator && aggregator.cpDetails) {
            let { type, subType } = aggregator.cpDetails;
            if (type === 'OTHER' || type === 'UNCLASSIFIED' || type === 'UNKNOWN') {
                type = 'UNKNOWN';
                subType = 'UNKNOWN';
            }
            discoveredAccount = (0, types_2.mkDiscoveredAccount)({
                shadowAccountId: account.shadowId,
                id: aggregator.id,
                cpId: aggregator.cpId,
                cpLoginId: aggregator.cpLoginId,
                channel: aggregator.channel,
                type,
                subType,
                name: (0, utils_1.replaceRawASCII)(aggregator.cpDetails.name),
                number: aggregator.cpDetails.maskedNumber,
                maskedNumber: aggregator.cpDetails.maskedNumber,
                balance: aggregator.cpDetails.balance,
                balanceAt: aggregator.cpDetails.balanceAt,
                currency: aggregator.cpDetails.currency,
            });
        }
        log.log('Discovered Account is', discoveredAccount);
        if (existingAccount) {
            if (discoveredAccount) {
                activeAccounts.push((0, types_2.mkActiveDiscoveredAccount)({
                    account: existingAccount,
                    discoveredAccount,
                }));
            }
            else if (aggregator) {
                deadAccounts.push(existingAccount);
            }
            else {
                unconnectedAccounts.push(existingAccount);
            }
        }
        else {
            if (!discoveredAccount) {
                log.error("We didn't discover an existing account yet were also missing new account information", account);
                return;
            }
            const { aggStatus } = aggregator.cpDetails;
            if (aggStatus === 'ACCOUNT_NOT_FOUND') {
                log.info("Skipping account because FDS has marked it as not found and we don't know about it anyways", account);
                return;
            }
            const { type } = discoveredAccount;
            if (type !== 'BANK' && type !== 'CREDIT' && type !== 'INVESTMENT' && type !== 'LOAN' && type !== 'UNKNOWN') {
                log.info(`Skipping unsupported account type, type=${type}`);
                return;
            }
            newAccounts.push(discoveredAccount);
        }
    });
    const accountDiscoveryData = (0, types_2.mkAccountDiscoveryData)({
        institutionLoginId: data.institutionLoginId,
        credentialsBlob: data.credentialsBlob,
        status: data.status,
        activeAccounts: (0, immutable_1.List)(activeAccounts),
        deadAccounts: (0, immutable_1.List)(deadAccounts),
        newAccounts: (0, immutable_1.List)(newAccounts),
        unconnectedAccounts: (0, immutable_1.List)(unconnectedAccounts),
    });
    log.debug('AccountDiscoveryData = ', accountDiscoveryData);
    return accountDiscoveryData;
};
exports.transformResponseToAccountDiscoveryData = transformResponseToAccountDiscoveryData;
function transformResponseToPartnerAuthUris(response) {
    const { data } = response;
    return (0, immutable_1.List)(data.uris);
}
exports.transformResponseToPartnerAuthUris = transformResponseToPartnerAuthUris;
// ================================================================================================
// Transformers for AccountDiscovery Status
// ================================================================================================
function transformResponseToAccountDiscoveryStatus(response) {
    const { data } = response;
    return (0, types_2.mkAccountDiscoveryStatus)({
        institutionLoginId: data.institutionLoginId,
        isProcessing: data.isProcessing,
        status: data.status,
        aggregators: !data.aggregators ? (0, immutable_1.List)() : (0, immutable_1.List)(data.aggregators.map((aggregator) => (0, types_2.mkAccountDiscoveryAggregatorStatus)({
            isProcessing: aggregator.isProcessing,
            aggStatus: aggregator.aggStatus,
            cpAggStatusCode: aggregator.cpAggStatusCode,
            cpAggStatusDetail: aggregator.cpAggStatusDetail,
            userInstructions: aggregator.userInstructions,
        }))),
    });
}
exports.transformResponseToAccountDiscoveryStatus = transformResponseToAccountDiscoveryStatus;
function transformAccountsToDiscoverAccount(institutionLogin, accounts) {
    const newAccounts = [];
    accounts.forEach((account) => {
        const { type } = account;
        if (type !== 'BANK' && type !== 'CREDIT' && type !== 'INVESTMENT' && type !== 'LOAN') {
            log.info(`Skipping unsupported account type, type=${type}`);
            return;
        }
        const aggregator = account.aggregators.get(0);
        const discoveredAccount = (0, types_2.mkDiscoveredAccount)({
            id: aggregator.id,
            cpId: aggregator.cpId,
            cpLoginId: aggregator.cpLoginId,
            channel: aggregator.channel,
            type,
            subType: account.subType,
            name: account.name,
            maskedNumber: aggregator.accountNumberMasked,
        });
        newAccounts.push(discoveredAccount);
    });
    const accountDiscoveryData = (0, types_2.mkAccountDiscoveryData)({
        institutionLoginId: institutionLogin.id,
        status: 'OK',
        newAccounts: (0, immutable_1.List)(newAccounts),
    });
    return accountDiscoveryData;
}
exports.transformAccountsToDiscoverAccount = transformAccountsToDiscoverAccount;
const transformPlaidItemActivityToRequestData = (institutionLogin, event) => ({
    event: event.name,
    sessionId: event.sessionId,
    requestId: event.requestId,
    institutionLoginId: institutionLogin ? institutionLogin.id : null,
    institutionId: event.institutionId,
    institutionName: event.institutionName,
    errorCode: event.errorCode,
    errorMessage: event.errorMessage,
    exitedAt: event.exitedAt,
});
exports.transformPlaidItemActivityToRequestData = transformPlaidItemActivityToRequestData;
const transformResponseToAggregationInfo = (response) => {
    const { data } = response;
    switch (data.aggregationPlatform) {
        case 'FINICITY':
            return (0, types_2.mkFinicityAggregationInfo)({
                connectUrl: data.finicity.connectUrl,
                pollingRef: data.pollingReference,
            });
        case 'PLAID':
            return (0, types_2.mkPlaidAggregationInfo)({
                linkToken: data.plaid.linkToken,
            });
        default:
            log.error('Unsupported aggregation platform', data.aggregationPlatform);
            return undefined;
    }
};
exports.transformResponseToAggregationInfo = transformResponseToAggregationInfo;
